<template>
  <v-dialog
      style="z-index: 202"
      :value="value"
      fullscreen
      persistent
      hide-overlay
      transition="dialog-bottom-transition">
    <v-card id="card">
      <v-toolbar
          dense
          style="position: relative"
          width="100%"
          color="primary"
          dark
      >
        <span class="font-weight-bold">レポート：{{ reportName }}</span>
        <v-spacer></v-spacer>
<!--        <p class="text-h6 report-name">{{ reportName }}</p>-->
<!--        <v-spacer></v-spacer>-->
        <div style="position: absolute; right: 60px">
          <div class="d-inline" v-if="checkEditable()">
            <v-btn @click="editReport" color="warning" class="mr-4" v-if="!editMode">
              <v-icon>mdi-file-document-edit</v-icon>
              編集
            </v-btn>
            <v-btn @click="editReport" class="mr-4" v-if="editMode">
              <v-icon>mdi-file-find</v-icon>
              編集完了
            </v-btn>
          </div>
          <v-btn
              @click="requestConfirmation"
              class="mr-4" color="success"
              light
              :disabled="reportApprovable || editMode"
              v-if="report && (report.status === 'NEW' || report.status === 'BRANCH_REQUEST_REJECTED' || report.status === 'AREA_REQUEST_REJECTED' || report.status === 'SUBMIT_REJECTED')"
          >
            <v-icon>mdi-share-all-outline</v-icon>
            1次承認依頼
          </v-btn>
          <v-btn
              @click="rejectConfirmation"
              class="mr-4"
              color="error"
              light
              :disabled="reportApprovable || editMode"
              v-if="report && (report.status === 'BRANCH_REQUESTED' && sharedState.email === report.branch_confirm_user)"
          >
            <v-icon>mdi-file-remove-outline</v-icon>
            却下
          </v-btn>
          <v-btn
              @click="requestAreaLeader"
              color="success"
              class="mr-4"
              light
              :disabled="reportApprovable || editMode"
              v-if="report && (report.status === 'BRANCH_REQUESTED' && sharedState.email === report.branch_confirm_user)"
          >
            <v-icon>mdi-file-send-outline</v-icon>
            承認（２次承認依頼）
          </v-btn>
          <v-btn
              @click="rejectAreaLeader"
              light
              class="mr-4"
              color="error"
              :disabled="reportApprovable || editMode"
              v-if="report && (report.status === 'AREA_REQUESTED' && sharedState.email === report.area_confirm_user)"
          >
            <v-icon>mdi-file-send-outline</v-icon>
            却下
          </v-btn>
          <v-btn
              @click="requestSubmit"
              light
              class="mr-4"
              color="success"
              :disabled="reportApprovable || editMode"
              v-if="report && (report.status === 'AREA_REQUESTED' && sharedState.email === report.area_confirm_user)"
          >
            <v-icon>mdi-file-send-outline</v-icon>
            承認（営業へ承認依頼）
          </v-btn>
          <v-btn
              @click="rejectSubmit"
              light
              class="mr-4"
              color="error"
              :disabled="reportApprovable || editMode"
              v-if="report && (report.status === 'SUBMIT_REQUESTED' && sharedState.email === report.submit_user)"
          >
            <v-icon>mdi-file-send-outline</v-icon>
            却下
          </v-btn>
          <v-btn
              @click="sendCustomer"
              light
              class="mr-4"
              color="success"
              :disabled="reportApprovable || editMode"
              v-if="report && (report.status === 'SUBMIT_REQUESTED' && sharedState.email === report.submit_user)"
          >
            <v-icon>mdi-file-send-outline</v-icon>
            顧客へ提出
          </v-btn>
          <v-btn
              @click="requestCancel"
              light
              class="mr-4 white--text"
              color="grey"
              v-if="cancelable"
          >
            <v-icon>mdi-close-circle-outline</v-icon>
            依頼キャンセル
          </v-btn>
          <report-confirm-history
              :report="report"
              :folderId="folderId"
          ></report-confirm-history>
          <v-btn
              @click="printReport"
              class="mr-4"
              light
              :disabled="!downloadable"
          >
            <v-icon>mdi-download</v-icon>
            ダウンロード
          </v-btn>
        </div>
        <v-spacer></v-spacer>
        <v-btn light fab small depressed v-on:click="close" :disabled="editMode">
          <v-icon size="20">mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pa-0">
        <div class="d-flex justify-center align-center" :style="`height: ${windowHeight - 48}px;`" v-if="!loaded">
          <v-progress-circular
              size="50"
              indeterminate
              color="primary"
              v-if="!loaded"
          ></v-progress-circular>
        </div>
        <v-row style="width: 100%" v-show="loaded">
          <v-col cols="auto" class="pr-0" style="min-width: 290px; max-width: 290px; position: relative; box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)">
            <v-alert v-if="editMode" type="error" dense text class="text-caption font-weight-bold">編集が完了するまで、戻るや画面更新やブラウザ閉じる操作を行わないでください。</v-alert>
            <v-list shaped>
              <v-list-item-group
                  v-model="selectedPage"
                  color="primary"
                  mandatory
              >
                <v-list-item v-for="(value, index) in naviList" :key="'v-list-item-'+index">
                  <template v-slot:default>
                    <v-list-item-content :class="value.visible ? '' : 'grey--text'" class="py-0">
                      <v-list-item-title v-if="!value.isNew && editPdfPage !== index" class="d-flex">
                        <span>{{ getPageOrderNumber(value) }} {{ value.text }}</span>
                      </v-list-item-title>
                      <v-list-item-title v-else-if="editMode">
                        <v-form :ref="`pdf_form_${index}`" class="py-0">
                          <div class="d-flex">
                            <div class="d-flex justify-start align-center"><span>{{ getPageOrderNumber(value) }} </span></div>
                            <v-form v-on:submit.prevent>
                              <v-text-field
                                  v-model="pdfPage.text"
                                  class="mb-0"
                                  rounded
                                  outlined
                                  hide-details="auto"
                                  dense
                                  :ref="`pdf_${index}`"
                                  autofocus
                                  :rules="[v => (!!v && !!v.trim()) || 'ページ名が必須']"
                              >
                                <template v-slot:append>
                                  <v-icon color="error" @click="cancelPdfPage" v-if="value.isNew">mdi-delete</v-icon>
                                </template>
                              </v-text-field>
                            </v-form>
                          </div>
                        </v-form>
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-icon
                        v-show="value.text === '概要' && getPageError(value.text)">
                      <v-icon color="error">mdi-alert</v-icon>
                    </v-list-item-icon>
                    <v-list-item-icon
                        v-show="value.text === '故障モード解説' && getPageError(value.text)">
                      <v-icon color="error">mdi-alert</v-icon>
                    </v-list-item-icon>
                    <v-list-item-icon
                        v-show="value.text === 'ドローン検査結果' && getPageError(value.text)">
                      <v-icon color="error">mdi-alert</v-icon>
                    </v-list-item-icon>
                    <v-list-item-icon
                        v-show="value.text === 'ドローン検査詳細（抜粋）' && getPageError(value.text)">
                      <v-icon color="error">mdi-alert</v-icon>
                    </v-list-item-icon>
                    <v-list-item-action v-if="value.text === 'サーマルオルソ画像' || value.text === 'RGBオルソ画像'">
                      <v-checkbox v-model="value.visible" @click.stop="click(value)" v-if="editMode" :disabled="!colorType.includes(value.value)"></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-action v-if="'isPdf' in value && !value.isNew && editMode">
                      <div class="d-flex">
                        <div v-if="editPdfPage !== index && !newPdfPage">
                          <v-icon color="primary" @click="editPageName(index)">mdi-pencil</v-icon>
                          <v-icon color="error" @click="deleteEditedPdfPage(index)">mdi-delete</v-icon>
                        </div>
                        <div v-else-if="!newPdfPage">
                          <v-icon @click="enterPageName" color="success" v-if="!!pdfPage.text && !!pdfPage.text.trim()">mdi-check</v-icon>
                          <v-icon @click="cancelEditPdfPage(index)" color="black">mdi-close</v-icon>
                        </div>
                      </div>
                    </v-list-item-action>
                  </template>
                </v-list-item>
              </v-list-item-group>
            </v-list>
            <div class="d-flex justify-center" v-if="editMode">
              <v-btn :disabled="newPdfPage || editPdfPage !== -1" rounded @click="readPDF">PDF読み込む</v-btn>
            </div>
          </v-col>
          <v-col cols :style="`max-height: ${windowHeight - 48}px; overflow: scroll;`">
            <div ref="print">
              <cover-page class="page"></cover-page>
              <content-table v-if="report" class="page" :naviList="naviList"
                             :naviVisibleList="naviList.filter(item => item.visible)"
                             :pdfPageNum="calculatePdfPageCount()"
                             :cropImagePageNum="cropImagePageNum"></content-table>
              <overview-page v-if="report" class="page" :report="report" :naviVisibleList="naviList.filter(item => item.visible)"
                             :pdfPageNum="calculatePdfPageCount()"
                             :cropImagePageNum="cropImagePageNum" :editMode="editMode"></overview-page>
              <thermal-page v-if="report" class="page" :report="report" v-show="naviList[3].visible && report && report.page_visible.includes('thermal')" :openReportDialog="value"
                            :naviVisibleList="naviList.filter(item => item.visible)"
                            :pdfPageNum="calculatePdfPageCount()"
                            @doneLoadingImage="doneLoadingImage"
                            @changeFilterReport="changeFilterReport"
                            :filterReport="filterReport" :editMode="editMode"
                            :annotationTypes="annotationTypes"
                            :cropImagePageNum="cropImagePageNum"></thermal-page>
              <color-page v-if="report" class="page" :report="report" v-show="naviList[4].visible && report && report.page_visible.includes('color')" :openReportDialog="value"
                          :naviVisibleList="naviList.filter(item => item.visible)"
                          :pdfPageNum="calculatePdfPageCount()"
                          @doneLoadingImage="doneLoadingImage"
                          @changeFilterReport="changeFilterReport"
                          :filterReport="filterReport" :editMode="editMode"
                          :annotationTypes="annotationTypes"
                          :cropImagePageNum="cropImagePageNum"></color-page>
              <explain-page v-if="report" class="page" :naviVisibleList="naviList.filter(item => item.visible)"
                            :pdfPageNum="calculatePdfPageCount()"
                            :cropImagePageNum="cropImagePageNum"></explain-page>
              <fault-map-page v-if="report" class="page" :naviVisibleList="naviList.filter(item => item.visible)" :editMode="editMode"
                              :cropImagePageNum="cropImagePageNum" :pdfPageNum="calculatePdfPageCount()"
                              :report="report" :printMode="printMode"></fault-map-page>
              <drone-result-page v-if="report" class="page" :report="report" :editMode="editMode"
                                 :naviVisibleList="naviList.filter(item => item.visible)"
                                 :pdfPageNum="calculatePdfPageCount()"
                                 :cropImagePageNum="cropImagePageNum"></drone-result-page>
              <drone-result-graph-page v-if="report" class="page" :report="report" :editMode="editMode"
                                 :naviVisibleList="naviList.filter(item => item.visible)"
                                 :pdfPageNum="calculatePdfPageCount()"
                                 :cropImagePageNum="cropImagePageNum"></drone-result-graph-page>
              <crop-image-page class="page" :report="report" :selectedImages="selectedImages"
                               v-for="i in cropImagePageNum" :key="i" :editMode="editMode"
                               :naviVisibleList="naviList.filter(item => item.visible)"
                               :pdfPageNum="calculatePdfPageCount()"
                               :cropImagePageNum="cropImagePageNum" :printMode="printMode"
                               @addBlank="addImageBlank" @removeBlank="removeImageBlank"
                               @openChooseCropImageDialog="openChooseCropImageDialog"></crop-image-page>
              <div v-for="(itm, idx) in naviList.slice(naviList.findIndex(item => item.text === 'ドローン検査詳細（抜粋）')+1)" :key="'pdf-item-' + idx">
                <pdf-page class="page"
                            :id="idx + '-pdf-page-' + index"
                            :naviVisibleList="naviList.filter(item => item.visible)"
                            :cropImagePageNum="cropImagePageNum"
                            :pdfPageNum="calculatePdfPageCount()"
                            :pdfNum="idx"
                            :pageOrder="index-1"
                            :title="itm.text"
                            :page="itm.pages[index-1].url"
                            :pdfId="itm.pages[index-1].id"
                            @doneLoadingPdfPage="doneLoadingPdfPage"
                            v-for="index in Number(itm.pageAmount)" :key="idx + '-pdf-page-' + index">
                </pdf-page>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <div id="cropImagePanel"
           :class="chooseCropImageDialog ? 'openChooseCropImageDialog' : 'closeChooseCropImageDialog'">
        <v-card-title>
          <span class="text-h6 font-weight-bold">検査詳細画像選択</span>
          <v-spacer></v-spacer>
          <v-btn fab small depressed outlined v-on:click="closeChooseCropImageDialog">
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container fluid :style="`width: 450px; max-height: ${windowHeight - 100}px; overflow: scroll;`" class="pa-0 pt-1">
            <v-row class="ml-0" style="width: 100%;">
              <v-col v-for="i in listCropImage" :key="i.src" class="pa-0" cols="6">
                <v-card height="202" class="mb-3">
                  <div class="image-container" @click="chooseImage(i)">
                    <img :src="i.src" style="height: 170px; width: 213px; " :class="i.selected ? 'image': null" ref="img"/>
                    <div class="icon" v-if="i.selected">
                      <div class="div-rounded blue">
                        <span class="text-subtitle-1 font-weight-bold white--text">{{ getImageIndex(i) + 1 }}</span>
                      </div>
                    </div>
                  </div>
                  <v-card-subtitle>
                    <div class="d-flex justify-center mb-2">
                      <span class="text-caption">{{errorType[i.errorType]}}</span>
                      <span v-if="i.errorReason" class="text-caption">（{{errorReason[i.errorReason]}}）</span>
                    </div>
                  </v-card-subtitle>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </div>
    </v-card>
    <request-confirmation-dialog
        v-model="openRequestConfirmationDialog"
        :folder-id="folderId"
        @requested="confirmationRequested"
        v-if="openRequestConfirmationDialog"
        :report="report"
        @updateOutdatedReport="updateOutdatedReport"
    ></request-confirmation-dialog>
    <reject-request-confirmation-dialog
        v-model="rejectConfirmationDialog"
        @rejected="rejectedConfirmation"
        :folder-id="folderId"
        :reject-type="rejectType"
        v-if="rejectConfirmationDialog"
        :report="report"
        @updateOutdatedReport="updateOutdatedReport"
    ></reject-request-confirmation-dialog>
    <request-leader-confirmation-dialog
        v-model="openRequestLeaderConfirmationDialog"
        :folder-id="folderId"
        @requested="confirmationRequested"
        v-if="openRequestLeaderConfirmationDialog"
        :report="report"
        @updateOutdatedReport="updateOutdatedReport"
    ></request-leader-confirmation-dialog>
    <request-seller-confirmation-dialog
        v-model="openReportSubmitDialog"
        :folder-id="folderId"
        @requested="confirmationRequested"
        v-if="openReportSubmitDialog"
        :report="report"
        @updateOutdatedReport="updateOutdatedReport"
    ></request-seller-confirmation-dialog>
    <pdf-upload-dialog
        v-model="openPdfUploadDialog"
        v-if="openPdfUploadDialog"
        @onUploadPdf="onUploadPdf"
        :folder-id="folderId"
    ></pdf-upload-dialog>
  </v-dialog>
</template>

<script>

import CoverPage from "@/components/dialog/report/CoverPage";
import ContentTable from "@/components/dialog/report/ContentTable";
import OverviewPage from "@/components/dialog/report/OverviewPage";
import {store} from "@/store";
import ThermalPage from "@/components/dialog/report/ThermalPage";
import ColorPage from "@/components/dialog/report/ColorPage";
import ExplainPage from "@/components/dialog/report/ExplainPage";
import FaultMapPage from "@/components/dialog/report/FaultMapPage";
import DroneResultPage from "@/components/dialog/report/DroneResultPage";
import CropImagePage from "@/components/dialog/report/CropImagePage";
import DroneResultGraphPage from "@/components/dialog/report/DroneResultGraphPage";
import RequestConfirmationDialog from "@/components/dialog/report/RequestConfirmationDialog";
import RejectRequestConfirmationDialog from "@/components/dialog/report/RejectRequestConfirmationDialog";
import RequestLeaderConfirmationDialog from "@/components/dialog/report/RequestLeaderConfirmationDialog";
import RequestSellerConfirmationDialog from "@/components/dialog/report/RequestSellerConfirmationDialog";
import moment from "moment";
import Vue from "vue";
import PdfPage from "@/components/dialog/report/PdfPage";
import PdfUploadDialog from "@/components/dialog/report/PdfUploadDialog";
import ReportConfirmHistory from "@/components/dialog/report/ReportConfirmHistory";

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).locale('ja').format('LLL')
  }
})

export default {
  name: "ReportDialog",
  props: ['value'],
  components: {
    ReportConfirmHistory,
    PdfUploadDialog,
    RequestSellerConfirmationDialog,
    RequestLeaderConfirmationDialog,
    RejectRequestConfirmationDialog,
    RequestConfirmationDialog,
    PdfPage,
    'cover-page': CoverPage,
    'content-table': ContentTable,
    'overview-page': OverviewPage,
    'thermal-page': ThermalPage,
    'color-page': ColorPage,
    'explain-page': ExplainPage,
    'fault-map-page': FaultMapPage,
    'drone-result-page': DroneResultPage,
    'drone-result-graph-page': DroneResultGraphPage,
    'crop-image-page': CropImagePage,
  },
  data() {
    return {
      reportName: null,
      selectedPage: 0,
      windowHeight: window.innerHeight,
      report: null,
      folderId: this.$route.params.folderId,
      listCropImage: [],
      selectedImages: [],
      cropImagePageNum: 1,
      chooseCropImageDialog: false,
      naviList: [
        {
          text: '表紙',
          visible: true,
          isNew: false,
          value: 'cover'
        },
        {
          text: '目次',
          visible: true,
          isNew: false,
          value: 'content'
        },
        {
          text: '概要',
          visible: true,
          isNew: false,
          value: 'overview'
        },
        {
          text: 'サーマルオルソ画像',
          visible: false,
          isNew: false,
          value: 'thermal'
        },
        {
          text: 'RGBオルソ画像',
          visible: false,
          isNew: false,
          value: 'color'
        },
        {
          text: '故障モード解説',
          visible: true,
          isNew: false,
          value: 'explain'
        },
        {
          text: 'ドローン検査結果',
          visible: true,
          isNew: false,
          value: 'droneResult'
        },
        {
          text: 'ドローン検査詳細（抜粋）',
          visible: true,
          isNew: false,
          value: 'cropImage'
        }
      ],
      editMode: false,
      printMode: false,
      loaded: false,
      errorType: {
        'cell': 'ホットスポット',
        'multicell': 'マルチホットスポット',
        'cluster': 'クラスタバイパス',
        'module': 'モジュール異常',
        'string': 'ストリング異常',
        'junction': 'ジャンクションボックス過熱',
        'pid': 'ＰＩＤ現象の疑い',
        'shadow': '影',
      },
      errorReason: {
        "crack": "割れ",
        "sediment": "堆積物",
        "vegetation": "植生"
      },
      newPdfPage: false,
      editPdfPage: -1,
      pdfPage: {
        text: '',
        pageAmount: 1
      },
      loadingThermalImage: true,
      loadingColorImage: true,
      filterReport: [],
      annotationTypes: {
        'cell': false,
        'multicell': false,
        'cluster': false,
        'module': false,
        'string': false,
        'junction': false,
        'pid': false,
        'shadow': false
      },
      openRequestConfirmationDialog: false,
      sharedState: store.state,
      openReportSubmitDialog: false,
      rejectConfirmationDialog: false,
      rejectType: null,
      openRequestLeaderConfirmationDialog: false,
      colorType: [],
      openPdfUploadDialog: false,
    }
  },
  methods: {
    close() {
      store.updateOpenDialog(false);
      this.$emit('input');
    },
    initCropImagePages(){
      this.listCropImage = [];
      this.selectedImages = [];
      const list = this.report.annotation_image.list;
      for (const [key, value] of Object.entries(list)) {
        for (const [k, v] of Object.entries(value.crop_shape_list)) {
          const image = {
            src: v.image,
            filename: key,
            crop_image_id: k,
            selected: v.selected,
            errorType: v.errorType,
            errorNote: v.errorNote,
            errorReason: v.errorReason,
            index: v.index
          };
          this.listCropImage.push(image);
          if (v.selected){
            this.selectedImages.push(image);
          }
        }
      }
      this.selectedImages.sort((a, b) => {
        return a.index - b.index;
      });
      let last = 0;
      const tempSelectedImages = JSON.parse(JSON.stringify(this.selectedImages));
      tempSelectedImages.forEach((item, index) => {
        if (index > 0){
          for (let i = 0; i < item.index - tempSelectedImages[index-1].index - 1; i++){
            this.selectedImages.splice(last + i, 0, {src: null});
          }
        }
        last = item.index + 1;
      })
      this.calculateCropImagePageNum();
    },
    initMapPages(){
      const thermal = this.naviList.find(i => i.value === 'thermal');
      thermal.visible = this.report.page_visible.includes('thermal');

      const color = this.naviList.find(i => i.value === 'color');
      color.visible = this.report.page_visible.includes('color');
    },
    getReport() {
      this.chooseCropImageDialog = false;
      this.report = null;
      this.axios
          .get('/api/report/' + this.folderId)
          .then((response) => {
            this.report = response.data.report;
            this.colorType = response.data.color_type;
            this.initMapPages();
            store.updateCurrentReportStatus(this.report.status);
            response.data.annotation.panel_abnormality.list.forEach(item => {
              this.annotationTypes[item.type] = true;
            });

            this.filterReport = this.report.filter.panel_error_types;
            this.updateReportName();
            this.initCropImagePages();
            this.loaded = true;
            this.initPdfPages(response.data.report_pdf_page[this.report.id]);
          })
          .catch(() => {
            store.showErrorDialog('エラーが発生しました。再度試してください。');
          });
    },
    calculateCropImagePageNum: function () {
      if (this.selectedImages.length > 0) {
        this.cropImagePageNum = Math.ceil(this.selectedImages.length / 3);
      } else {
        this.cropImagePageNum = 1;
      }
    },
    chooseImage(image) {
      image.selected = !image.selected;
      this.axios.put('/api/report/choose-image/' + this.folderId, {image: image, index: this.selectedImages.length});
      if (image.selected) {
        this.selectedImages.push(image);
      } else {
        const i = this.selectedImages.findIndex(item => item.crop_image_id === image.crop_image_id);
        if (i >= 0) {
          this.selectedImages.splice(i, 1);
        }
      }
      this.updateImagesIndex();
      this.calculateCropImagePageNum();
    },
    closeChooseCropImageDialog() {
      this.chooseCropImageDialog = false;
    },
    openChooseCropImageDialog() {
      this.chooseCropImageDialog = !this.chooseCropImageDialog;
    },
    getImageIndex(image) {
      return this.selectedImages.filter(item => item.src).findIndex(item => item.crop_image_id === image.crop_image_id);
    },
    click(page) {
      store.showLoadingOverlay(true);
      this.axios
          .put('/api/report/page/' + this.folderId, {page: page.value, visible: page.visible})
          .then((response) => {
            this.report.page_visible = response.data.page_visible;
            store.showLoadingOverlay(false);
          }).catch(() => {
            store.showLoadingOverlay(false);
            store.showErrorDialog('エラーが発生しました。再度試してください。')
          });
    },
    editReport() {
      this.axios
          .put('/api/report/edit/' + this.folderId, {mode: !this.editMode, updated_at: this.report.updated_at})
          .then((response) => {
            this.editMode = !this.editMode;
            if (!this.editMode){
              this.editPdfPage = -1;
              if (this.newPdfPage){
                this.naviList.splice(this.naviList.length-1, 1);
              }
              this.newPdfPage = false;
              this.report.updated_at = response.data.updated_at;
            }
          })
          .catch((error) => {
            store.showErrorDialog(error.response.data.message);
            if (error.response.status === 403 || error.response.status === 409){
              for (const [key, value] of Object.entries(error.response.data.report)){
                this.report[key] = value;
              }
              this.initMapPages();
              this.initCropImagePages();
              this.$root.$emit('reportUpdated');
            }
            if (error.response.status === 409){
              this.editMode = false;
            }
          })
    },
    downloadReport() {

    },
    printReport() {
      this.editMode = false;
      this.printMode = true;
      const WinPrint = window.open('/report/' + this.folderId, '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
      WinPrint.onload = () => {
        WinPrint.document.title = this.reportName;
        WinPrint.focus();
        WinPrint.document.getElementsByTagName('header')[0].remove();
        WinPrint.document.getElementsByClassName('v-main')[0].style.padding = '0';
        WinPrint.document.getElementById('temp').outerHTML = JSON.parse(JSON.stringify(this.$refs.print.outerHTML));
        WinPrint.document.getElementById('cover-page').classList.replace('page', 'page_print');
        WinPrint.document.getElementById('content-table').classList.replace('page', 'page_print');
        WinPrint.document.getElementById('overview-page').classList.replace('page', 'page_print');
        WinPrint.document.getElementById('thermal-page').classList.replace('page', 'page_print');
        WinPrint.document.getElementById('color-page').classList.replace('page', 'page_print');
        WinPrint.document.getElementById('explain-page').classList.replace('page', 'page_print');
        WinPrint.document.getElementById('fault-map-page').classList.replace('page', 'page_print');
        WinPrint.document.getElementById('drone-result-page').classList.replace('page', 'page_print');
        WinPrint.document.getElementById('drone-result-graph-page').classList.replace('page', 'page_print');
        WinPrint.document.getElementById('crop-image-page').classList.replace('page', 'page_print');
        const list = WinPrint.document.getElementsByClassName('crop-image-page');
        for (let i = 0; i < list.length; i++) {
          list[i].classList.remove('page');
          list[i].classList.add('page_print');
        }
        const naviList = this.naviList.slice(this.naviList.findIndex(item => item.text === 'ドローン検査詳細（抜粋）')+1);
        naviList.forEach((item, idx) => {
          for (let index = 1; index <= Number(item.pageAmount); index++) {
            WinPrint.document.getElementById(`${idx}-pdf-page-${index}`).classList.replace('page', 'page_print');
          }
        })
        WinPrint.onafterprint = () => {
          setTimeout(() => {WinPrint.close();}, 100);
          this.printMode = false;
        }
        let incrementCounter;
        incrementCounter = () => {
          counter++;
          if (counter === len){
            setTimeout(() => {WinPrint.print();}, 100);
          }
        }
        let imgs = WinPrint.document.images, len = imgs.length, counter = 0;
        if (imgs.length > 0){
          Array.from(imgs).forEach((img) => {
            if (img.complete){
              incrementCounter();
            }
            else {
              img.addEventListener('load', incrementCounter, false);
            }
          })
        }
        else {
          setTimeout(() => {WinPrint.print();}, 100);
        }
      }
    },
    updateReportName(){
      if (this.report){
        this.reportName = this.report.plantName + '_' + this.report.shootingDate;
      }
    },
    getPageError(value){
      const requiredPlantInfo = [
        'plantAddress',
        'plantDC',
        'plantAC',
        'plantModuleNum',
        'stringErrorModuleNum',
        'plantModuleModel',
        'plantModuleMaker',
        'shootingDate'
      ];
      switch (value){
        case '概要': {
          if (this.report){
            let check = false;
            requiredPlantInfo.forEach((i) => {
              check = check || !this.report[i] || this.report[i] === '0' || this.report[i] === '';
            })
            return check;
          }
          return false;
        }
        case '故障モード解説': {
          if (this.report){
            return !this.report.faultMap;
          }
          return false;
        }
        case 'ドローン検査結果': {
          if (this.report){
            return !this.report.summary;
          }
          return false;
        }
        case 'ドローン検査詳細（抜粋）': {
          return this.selectedImages.filter(i => i.src).length === 0;
        }
      }
    },
    onResize(){
      this.windowHeight = window.innerHeight;
    },
    addImageBlank(index){
      this.selectedImages.splice(index, 0, {'src': null});
      this.updateImagesIndex();
    },
    removeImageBlank(index){
      this.selectedImages.splice(index, 1);
      this.updateImagesIndex();
    },
    updateImagesIndex(){
      this.selectedImages.forEach((item, index) => {
        item.index = index;
      });
      this.axios.put('/api/report/images-index/' + this.folderId, {'images': this.selectedImages});
    },
    enterPageName(){
      if (this.$refs[`pdf_form_${this.editPdfPage}`][0].validate()){
        const oldName = this.naviList[this.editPdfPage].text;
        const newName = this.pdfPage.text;
        this.naviList[this.editPdfPage].text = newName;
        this.axios
            .put('/api/report/pdf-page/',
                {upload_order: this.naviList[this.editPdfPage].pages[0].upload_order, new_name: newName, report_id: this.report.id}
            )
            .catch(() => {
              this.naviList[this.editPdfPage].text = oldName;
              store.showErrorDialog('エラーが発生して、編集できませんでした。再度試してください。');
            });

        this.editPdfPage = -1;
        this.pdfPage = {text: '', pageAmount: 1};
      }
      else {
        this.$refs[`pdf_number_${this.editPdfPage}`][0].focus()
      }
    },
    cancelPdfPage(){
      this.naviList.splice(this.naviList.length-1, 1);
      this.newPdfPage = false;
      this.pdfPage = {text: '', pageAmount: 1};
    },
    cancelEditPdfPage(){
      this.editPdfPage = -1;
      this.pdfPage = {text: '', pageAmount: 1};
    },
    deleteEditedPdfPage(index){
      const deleted = this.naviList.splice(index, 1);
      this.naviList.forEach(item => {
        if ('index' in item){
          if (item.index > deleted[0].index){
            item.index -= 1;
          }
        }
      });
      this.axios
          .delete('/api/report/pdf-page/', {data: {upload_order: deleted[0].pages[0].upload_order, report_id: this.report.id}})
          .catch(() => {
            store.showErrorDialog('エラーが発生しました。削除できませんでした。再度試してください。');
          });
      this.editPdfPage = -1;
      this.pdfPage = {text: '', pageAmount: 1};
    },
    editPageName(index){
      this.editPdfPage = index;
      this.pdfPage = {text: this.naviList[index].text, pageAmount: this.naviList[index].pageAmount};
    },
    calculatePdfPageCount(){
      let num = 0;
      const list = this.naviList.slice(this.naviList.findIndex(item => item.text === 'ドローン検査詳細（抜粋）')+1)
      list.forEach(item => {
        num += Number(item.pageAmount)-1;
      });
      return num;
    },
    doneLoadingImage(color){
      if (color === 'color'){
        this.loadingColorImage = false;
      }
      else {
        this.loadingThermalImage = false;
      }
    },
    changeFilterReport(filterReport){
      this.filterReport = filterReport;
    },

    requestConfirmation(){
      this.editMode = false;
      this.openRequestConfirmationDialog = true;
    },

    rejectConfirmation(){
      this.rejectType = 'branch_reject';
      this.rejectConfirmationDialog = true;
    },

    requestAreaLeader(){
      this.openRequestLeaderConfirmationDialog = true;
    },

    rejectAreaLeader(){
      this.rejectType = 'area_reject';
      this.rejectConfirmationDialog = true;
    },

    requestSubmit(){
      this.openReportSubmitDialog = true;
    },

    rejectSubmit(){
      this.rejectType = 'seller_reject';
      this.rejectConfirmationDialog = true;
    },

    sendCustomer(){
      const confirmDialog = {
        title: '顧客通知',
        content: '顧客に送信します。よろしいですか。',
        onAgree: () => {
          this.axios
              .post('/api/report/send-customer/' + this.folderId, {updated_at: this.report.updated_at})
              .then((response) => {
                store.showSuccessDialog('顧客に送信しました。');
                this.getReport();
                this.$root.$emit('reportStatusChanged', response.data);
              })
              .catch((error) => {
                store.showErrorDialog(error.response.data.message);
                if (error.response.status === 403){
                  this.updateOutdatedReport(error.response.data.report, error.response.data.report_pdf_pages);
                }
              })
        },
        onDisagree: () => {}
      };
      store.showConfirmDialog(confirmDialog);
    },

    confirmationRequested(status){
      this.getReport();
      this.$root.$emit('reportStatusChanged', status);
    },
    rejectedConfirmation(status){
      this.getReport();
      this.$root.$emit('reportStatusChanged', status);
    },
    checkEditable(){
      if (this.report){
        switch (this.report.status) {
          case 'NEW':
          case 'BRANCH_REQUEST_REJECTED':
          case 'AREA_REQUEST_REJECTED':
          case 'SUBMIT_REJECTED':
            return true;

          case 'BRANCH_REQUESTED':
            return store.state.email === this.report.branch_confirm_user;

          case 'AREA_REQUESTED':
            return store.state.email === this.report.area_confirm_user;
        }
      }
      return false;
    },
    closeBrowser(e){
      if (this.editMode){
        e.preventDefault();
        this.editReport();
        return e.returnValue = "閉じる";
      }
    },
    requestCancel(){
      const confirmDialog = {
        title: '依頼キャンセル',
        content: '承認依頼をキャンセルします。よろしいですか。',
        onAgree: () => {
          this.axios
              .post('/api/report/request-cancel/' + this.folderId, {updated_at: this.report.updated_at})
              .then((response) => {
                store.showSuccessDialog('承認依頼をキャンセルしました。')
                this.getReport();
                this.$root.$emit('reportStatusChanged', response.data.status);
              })
              .catch((error) => {
                store.showErrorDialog(error.response.data.message);
                if (error.response.status === 403){
                  this.updateOutdatedReport(error.response.data.report, error.response.data.report_pdf_pages);
                }
              })
        },
        onDisagree: () => {}
      };
      store.showConfirmDialog(confirmDialog);
    },
    updateOutdatedReport(report, report_pdf_pages){
      for (const [key, value] of Object.entries(report)){
        this.report[key] = value;
      }
      this.initMapPages();
      this.initCropImagePages();
      this.initPdfPages(report_pdf_pages);
      this.$root.$emit('reportUpdated');
      if (this.report.status !== store.state.currentReportStatus){
        store.updateCurrentReportStatus(this.report.status)
        this.$root.$emit('reportStatusChanged', this.report.status);
      }
    },
    readPDF(){
      this.openPdfUploadDialog = true;
    },
    onUploadPdf(pdfPages){
      this.naviList.push({
        text: pdfPages[0].name,
        visible: true,
        isPdf: false,
        index: this.naviList.length,
        pageAmount: pdfPages.length,
        pages: pdfPages,
        loading: true,
        isNew: false
      });
      this.newPdfPage = false;
    },
    initPdfPages(report_pdf_page){
      if (report_pdf_page){
        this.naviList = this.naviList.filter(i => !('isPdf' in i));
        Object.values(report_pdf_page).forEach((val) => {
          const pages = [];
          Object.values(val).forEach(page => {
            pages.push(page);
          });

          this.naviList.push({
            text: pages[0].name,
            visible: true,
            isPdf: false,
            index: this.naviList.length,
            pageAmount: pages.length,
            pages: pages,
            loading: true,
            isNew: false
          });
        });
      }
    },
    doneLoadingPdfPage(pdfId){
      const naviList = this.naviList.filter(i => ('isPdf' in i)).find(i => i.pages.find(v => v.id === pdfId));
      if (naviList){
        if (naviList.loading){
          naviList.loading = false;
        }
      }
    },
    getPageOrderNumber(value){
      if ('isPdf' in value){
        return this.naviList.filter(i => i.visible).findIndex(i => 'isPdf' in i && i.pages[0].upload_order === value.pages[0].upload_order) - 1 + '.';
      }
      return this.naviList.filter(i => i.visible).findIndex(i => i.text === value.text) > 1 ? this.naviList.filter(i => i.visible).findIndex(i => i.text === value.text) - 1 + '.' : '※';
    }
  },

  computed: {
    reportApprovable() {
      const requiredPlantInfo = [
        'plantAddress',
        'plantDC',
        'plantAC',
        'plantModuleNum',
        'stringErrorModuleNum',
        'plantModuleModel',
        'plantModuleMaker',
        'shootingDate'
      ];
      let check = false;
      requiredPlantInfo.forEach((i) => {
        check = check || !this.report[i] || this.report[i] === '0' || this.report[i] === '';
      });

      check = check || !this.report.summary || this.report === '';

      check = check || this.selectedImages.filter(i => i.src).length === 0;
      return check;
    },
    cancelable(){
      if (this.report){
        switch (this.report.status) {
          case 'BRANCH_REQUESTED': {
            return this.sharedState.email === this.report.request_user;
          }
          case 'AREA_REQUESTED': {
            return this.sharedState.email === this.report.branch_confirm_user;
          }
          case 'SUBMIT_REQUESTED': {
            return this.sharedState.email === this.report.area_confirm_user;
          }
          default: {
            return false;
          }
        }
      }
      return false;
    },
    downloadable(){
      return this.naviList.filter(i => ('isPdf' in i)).every(i => !i.loading) && !(this.editMode || this.loadingThermalImage || this.loadingColorImage);
    }
  },

  created() {
    store.updateOpenDialog(true);
    this.getReport();
    this.naviVisibleList = this.naviList.filter(item => {
      return item.visible;
    });
  },

  mounted() {
    // Register an event listener when the Vue component is ready
    window.addEventListener('resize', this.onResize);
    window.addEventListener('beforeunload', this.closeBrowser);
  },

  beforeDestroy() {
    // Unregister the event listener before destroying this Vue instance
    window.removeEventListener('resize', this.onResize);
    window.removeEventListener('beforeunload', this.closeBrowser);
  },

  watch: {
    'report.plantName': function (){
      this.updateReportName();
    },
    'report.shootingDate': function (){
      this.updateReportName();
    },
    selectedPage(selectedPage) {
      switch (selectedPage) {
        case 0: {
          if (this.naviList[selectedPage].visible) {
            document.getElementById('cover-page').scrollIntoView({behavior: 'smooth'});
          }
          break;
        }
        case 1: {
          if (this.naviList[selectedPage].visible) {
            document.getElementById('content-table').scrollIntoView({behavior: 'smooth'});
          }
          break;
        }
        case 2: {
          if (this.naviList[selectedPage].visible) {
            document.getElementById('overview-page').scrollIntoView({behavior: 'smooth'});
          }
          break;
        }
        case 3: {
          if (this.naviList[selectedPage].visible) {
            document.getElementById('thermal-page').scrollIntoView({behavior: 'smooth'});
          }
          break;
        }
        case 4: {
          if (this.naviList[selectedPage].visible) {
            document.getElementById('color-page').scrollIntoView({behavior: 'smooth'});
          }
          break;
        }
        case 5: {
          if (this.naviList[selectedPage].visible) {
            document.getElementById('explain-page').scrollIntoView({behavior: 'smooth'});
          }
          break;
        }
        case 6: {
          if (this.naviList[selectedPage].visible) {
            document.getElementById('drone-result-page').scrollIntoView({behavior: 'smooth'});
          }
          break;
        }
        case 7: {
          if (this.naviList[selectedPage].visible) {
            document.getElementById('crop-image-page').scrollIntoView({behavior: 'smooth'});
          }
          break;
        }
        default: {
          if (this.naviList[selectedPage].visible){
            document.getElementById(`${selectedPage - this.naviList.findIndex(item => item.text === 'ドローン検査詳細（抜粋）')-1}-pdf-page-1`).scrollIntoView({behavior: 'smooth'});
          }
        }
      }
    },
    'selectedImages': function (){
      this.calculateCropImagePageNum()
    }
  }
}
</script>

<style scoped>
*{
  -webkit-print-color-adjust: exact;
}
.page {
  margin: 0px auto 50px;
  height: 297mm;
  width: 210mm;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)
}
@page {
  size: A4;
  margin: 0;
}
.page_print{
  margin: auto;
  height: 297mm;
  width: 210mm;
}

#cropImagePanel {
  position: absolute;
  top: 48px;
  bottom: 0;
  background: white;
  width: 450px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)
}

.icon {
  transition: .5s ease;
  opacity: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;
}

.image-container {
  position: relative;
}

.image-container:hover {
  cursor: pointer;
}

.image-container .icon {
  opacity: 1;
}

.image-container .image {
  opacity: 0.4;
}

.div-rounded {
  display: inline-block;
  border: 1px solid #000000;
  border-radius: 50%;
  height: 30px;
  width: 30px;
}

@keyframes open-choose-crop-image-dialog {
  from {
    left: -100%;
  }
  to {
    left: 0;
  }
}

.openChooseCropImageDialog {
  animation: open-choose-crop-image-dialog;
  animation-duration: 0.5s;
  animation-delay: 0s;
  left: 0;
}

@keyframes close-choose-crop-image-dialog {
  from {
    left: 0;
  }
  to {
    left: -100%;
    visibility: hidden;
  }
}

.closeChooseCropImageDialog {
  animation: close-choose-crop-image-dialog;
  animation-duration: 0.5s;
  animation-delay: 0s;
  left: -100%;
}

.report-name {
  position: absolute;
  top: 8px;
  right: 50%;
  transform: translateX(50%);
}

@media print {
  body, html, #card {
    height: 100%;
  }
  .page_print{
    page-break-inside: avoid;
  }
}
>>>.v-text-field--rounded > .v-input__control > .v-input__slot{
  padding-right: 3px;
  padding-left: 10px;
}
</style>
